import fetch from 'dva/fetch';
// const ACCEPT_IMAGE_TYPES = /^image\/(jpe?g|png)$/i;
// const BASE64_REGX = /^data\/image\/(jpg?g|png);base64,/;

// export function uploadImageCheck(file) {
//   if (!file.type || !ACCEPT_IMAGE_TYPES.test(file.type)) {
//     return '格式不是jpg、jpeg或png';
//   }
//   if (file.size > 16 * 1024 * 1024) {
//     return '图片过大';
//   }
// }

export function uploadImageCheck(base64) {
  // if (!BASE64_REGX.test(base64)) {
  //   return '格式不是jpg、jpeg或png';
  // }
  const imgSize = getImgSizeByBase64(base64);
  console.log('imgSize: ', imgSize);
  if (imgSize > 3 * 1024 * 1024) {
    return '图片过大';
  }
}

export function getImgSizeByBase64(base64) {
  const equalIndex = base64.indexOf('='); // 获取=号下标
  let size;
  if (equalIndex > 0) {
    const str = base64.substring(0, equalIndex); // 去除=号
    const strLength = str.length;
    const fileLength = strLength - (strLength / 8) * 2; // 真实的图片byte大小
    size = Math.floor(fileLength); // 向下取整
  } else {
    const strLength = base64.length;
    const fileLength = strLength - (strLength / 8) * 2;
    size = Math.floor(fileLength); // 向下取整
  }
  return size;
}

/** 将base64转换为文件对象
 *  @param {String} base64 base64字符串
 * */
export function convertBase64ToBlob(base64) {
  const base64Arr = base64.split(',');
  let imgtype = '';
  let base64String = '';
  if (base64Arr.length > 1) {
    //如果是图片base64，去掉头信息
    base64String = base64Arr[1];
    imgtype = base64Arr[0].substring(base64Arr[0].indexOf(':') + 1, base64Arr[0].indexOf(';'));
  }
  // 将base64解码
  const bytes = atob(base64String);
  //var bytes = base64;
  const bytesCode = new ArrayBuffer(bytes.length);
  // 转换为类型化数组
  let byteArray = new Uint8Array(bytesCode);

  // 将base64转换为ascii码
  for (let i = 0; i < bytes.length; i++) {
    byteArray[i] = bytes.charCodeAt(i);
  }

  // 生成Blob对象（文件对象）
  return new Blob([bytesCode], { type: imgtype || 'image/png' });
}

export const convertBase64ToFile = base64Data => {
  const byteCharacters = atob(base64Data);
  const byteArrays = [];
  for (let i = 0; i < byteCharacters.length; i++) {
    byteArrays.push(byteCharacters.charCodeAt(i));
  }
  const byteArray = new Uint8Array(byteArrays);
  const blobFile = new Blob([byteArray], { type: 'image/jpeg' });
  return blobFile;
};
